import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import Skeleton from 'react-loading-skeleton';
import StripeMobilePayment from './StripeMobilePayment';
import Papa from 'papaparse';
import axios, { all } from 'axios';
import { BASE_URL } from "../../config";
import Coupons from '../coupons';
import backArrow from "../../assets/images/arrow-back-icon.svg";
import membershipIcon from "../../assets/images/membership-icon.svg";
import magicStar from "../../assets/images/magic-star.svg";
import authStorage from "../../utils/authStorage";

const MembershipMobileManaged = () => {
  const [paymentPage, setPaymentPage] = useState('');
  const [paymentPageLoaded, setPaymentPageLoaded] = useState(true);
  const [planDetail, setPlanDetail] = useState({});
  const [csvData, setCsvData] = useState('');
  const [loading, setLoading] = useState(true);
  const [allPlan, setAllPlan] = useState([]);
  const [isCoupenValid, setISCoupenValid] = useState();
  const [discount, setDiscount] = useState();
  const [email, setEmail] = useState();
  const [selectedPlan, setSelectedPlan] = useState(null);

  authStorage.getItem('roles')

  useEffect(() => {
    let userType = authStorage.getItem('roles');

    // If subscribedStatus is falsy, redirect to membership page
    if (userType == 'company') {
      window.location = window.location.origin + '/dashboard';
      return false;
    }
  })

  const [subId, setSubId] = useState();

  const fetchPlans = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/admin/allSub`, {
        headers: {
          "x-access-token": authStorage.getItem("auth-token"),
        },
      });
      setAllPlan(response?.data?.data);
    } catch (error) {
      console.error("Error fetching membership:", error);
    }
  };

  const getDeviceStatus = () => {
    setLoading(true);
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/subscription/status`, //your url
      method: "GET",
    }).then((res) => {
      setLoading(false);
      console.log(res.data, " ")
      setPlanDetail(res.data);

      const firstActive = res.data.PayAmount.find((p) => p?.info?.isActive)
        || planDetail.PayAmount[0];
      setSelectedPlan(firstActive);
    });
  };

  useEffect(() => {
    if (paymentPage) {
      return;
    }
    getDeviceStatus();
  }, [paymentPage]);

  const handleCsvDownload = (jsonData) => {
    const csv = Papa.unparse(jsonData);
    setCsvData(csv);

    // Optional: Save CSV data to a file
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'data.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const downloadBillingReport = () => {
    handleCsvDownload([{
      "User Range": userDetails?.userRange,
      "Price Per User": userDetails?.price,
      "Active CFT User": userDetails?.userCount,
      "Expected CFT User": userDetails?.expectedCftUser,
      "Total Cost": userDetails?.price * ((parseInt(userDetails?.expectedCftUser) > parseInt(userDetails?.userCount)) ? parseInt(userDetails?.expectedCftUser) : parseInt(userDetails?.userCount))
    }]);
  };

  const isCompanyAdmin = ['company'].includes(authStorage.getItem('roles'));
  let userDetails = authStorage.getItem('user');
  /*if (userDetails) {
    userDetails = JSON.parse(userDetails);
  }
  */
 if (userDetails) {
      try {
          userDetails = JSON.parse(userDetails);
      } catch (error) {
          console.error("Failed to parse userDetails:", error);
          userDetails = {}; // or null, depending on your needs
      }
  }
  useEffect(() => {
    fetchPlans();
    setISCoupenValid(authStorage.getItem('coupon')); setEmail(authStorage.getItem('email'))
  }, [])

  return (
  <>
    <style>{`
      .dashboard {
        padding: 0 !important;
      }
    `}</style>
    <div className="mobile-wrapper">
      {loading && (
        <div role="status">
          <svg
            aria-hidden="true"
            className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051..."
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038..."
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      )}

      {!loading && (
        planDetail?.subscribedStatus ? (
          <div>You are already subscribed</div>
        ) : (
          !isCompanyAdmin ? (
            <div>
              <div className="header">
                <span className="back-btn">
                  {/* <a href="#">
                    <img src={backArrow} alt="Icon" />
                  </a> */}
                </span>
                <div className="header-title">Membership Plan</div>
              </div>

              <div style={{ padding: "0 20px" }} class={`${(paymentPage && paymentPageLoaded) ? '' : 'hidden'}`} >
                <section>
                  <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-10 lg:px-6">
                    <div className="flex flex-col p-0 mx-auto max-w-lg text-center text-gray-300  xl:p-8 dark:bg-gray-800 dark:text-black">
                      <p>redirecting to stripe...</p>
                      <StripeMobilePayment paymentType={paymentPage} setPaymentPage={setPaymentPage} setPaymentPageLoaded={setPaymentPageLoaded} emails={email}
                        discount={discount} subId={subId}
                      />
                    </div>
                  </div>
                </section>
              </div>

              <div style={{ padding: "0 20px" }} class={`${(!paymentPage && paymentPageLoaded) ? '' : 'hidden'}`}>
                <div className="overview-component membership-overview">
                  <div className="icon-box">
                    <img src={membershipIcon} alt="Icon" />
                  </div>
                  <p>Membership provides access to exclusive content and tools for monitoring your activity.</p>
                </div>

                <div className="col-box-component style-2">

                  {planDetail?.PayAmount.map((data) => (
                    data?.info?.isActive && (
                      <div
                        key={data?.info?.type}
                        className={`col-box ${selectedPlan?.info?._id === data?.info?._id ? 'active' : ''}`}
                        onClick={() => setSelectedPlan(data)}
                      >
                        {selectedPlan?.info?._id === data?.info?._id && (
                          <div className="col-header">
                            <img src={magicStar} alt="Icon" /> Best value
                          </div>
                        )}

                        <div className="content-box-component">
                          <div className="price-box-component">
                            <div className="price-box">
                              <span className="price">${data?.formattedNumber}</span>
                              /{data?.info?.type}
                            </div>
                          </div>
                          <div className="title">{data?.info?.title}</div>
                          <ul>
                            {data?.info?.benefits.map((d, idx) => (
                              <li key={idx}>{d}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )
                  ))}
                </div>
              </div>
              {selectedPlan && (
                    <div className="footer-component">
                      <div className="">
                        <div className="price-box-component">
                          <div>
                            <div className="price-box">
                              <span className="price">${selectedPlan?.formattedNumber}</span>
                              /{selectedPlan?.info?.type}
                            </div>
                            <span className="pro-txt">{selectedPlan?.info?.title}</span>
                          </div>
                          <button
                            className="continue-btn cursor-pointer"
                            disabled={paymentPage && !paymentPageLoaded} // disable when loading
                            onClick={() => {
                              setSubId(selectedPlan?.info?._id);
                              setPaymentPage(selectedPlan?.info?.price);
                              setDiscount(selectedPlan?.discountPer);
                              setPaymentPageLoaded(false); // mark as loading
                            }}
                          >
                            {paymentPage && !paymentPageLoaded ? "Continue..." : "Continue"}

                            {(paymentPage && !paymentPageLoaded) && (
                              <svg
                                aria-hidden="true"
                                role="status"
                                className="inline w-4 h-4 ml-3 text-white animate-spin"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051..."
                                  fill="#E5E7EB"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038..."
                                  fill="currentColor"
                                />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
            </div>
          ) : (
            <></>
          )
        )
      )}
    </div>
       </>
  );

};

export default MembershipMobileManaged;
